import Assessor from './assessor';
import IntroductionKeywordAssessment from '../assessments/seo/IntroductionKeywordAssessment';
import MetaDescriptionKeywordAssessment from '../assessments/seo/MetaDescriptionKeywordAssessment';
import MetaDescriptionLength from '../assessments/seo/MetaDescriptionLengthAssessment';
import SubheadingsKeyword from '../assessments/seo/SubHeadingsKeywordAssessment';
import OutboundLinks from '../assessments/seo/OutboundLinksAssessment';
import KeyphraseDensityAssessment from '../assessments/seo/KeywordDensityAssessment';
import InternalLinksAssessment from '../assessments/seo/InternalLinksAssessment';
import SlugKeywordAssessment from '../assessments/seo/UrlKeywordAssessment';
import ImageCount from '../assessments/seo/ImageCountAssessment';
import TitleWidth from '../assessments/seo/PageTitleWidthAssessment';
import SingleH1Assessment from '../assessments/seo/SingleH1Assessment';
import KeyphraseAssessment from '../assessments/seo/KeyphraseAssessment';
import SingleTitleAssessment from '../assessments/seo/SingleTitleAssessment';
import UrlLengthAssessment from '../assessments/seo/UrlLengthAssessment';
import NumberInMetaTitleAssessment from '../assessments/seo/NumberInMetaTitleAssessment';
import TextImagesAssessment from '../assessments/seo/TextImagesAssessment';
import TextLengthAssessment from '../assessments/seo/TextLengthAssessment';
import MetaTitleKeywordAssessment from '../assessments/seo/MetaTitleKeywordAssessment';
import SchemaAssessment from '@axyseo/scoring/assessments/seo/SchemaAssessment';
import FAQsAssessment from '../assessments/seo/FAQsAssessment';
import KeywordFAQsAssessment from '../assessments/seo/KeywordFAQsAssessment';
import InvalidCharactersInUrl from '../assessments/seo/InvalidCharactersInUrl';
import FAQsStructureDataAssessment from '@axyseo/scoring/assessments/seo/FAQsStructureDataAssessment';
import RelatedKeywordsDensityAssessment from '@axyseo/scoring/assessments/seo/RelatedKeywordsDensityAssessment';

/**
 * The SEOAssessor class is used for the general SEO analysis.
 */
export default class SEOAssessor extends Assessor {
  /**
   * Creates a new SEOAssessor instance.
   * @param {Researcher}	researcher	The researcher to use.
   * @param {Object}		[config]	The assessor config.
   */
  constructor(researcher, config = {}) {
    super(researcher, config);
    this.type = 'SEOAssessor';

    this._assessments = [
      new MetaTitleKeywordAssessment(config?.titleKeyword),
      new TextImagesAssessment(config?.textImages),
      new NumberInMetaTitleAssessment(config?.numberTitle),
      new IntroductionKeywordAssessment(config?.introductionKeyword),
      new MetaDescriptionKeywordAssessment(config?.metaDescriptionKeyword),
      new MetaDescriptionLength(config?.metaDescriptionLength),
      new SubheadingsKeyword(config?.subheadingsKeyword),
      new OutboundLinks(config?.externalLinks),
      new KeyphraseDensityAssessment(config?.keyphraseDensity),
      new ImageCount(config?.media),
      new UrlLengthAssessment(config?.urlLength),
      new SingleTitleAssessment(config?.singleTitle),
      new KeyphraseAssessment(config?.keyphrase),
      new InternalLinksAssessment(config?.internalLinks),
      new TitleWidth(config?.titleWidth),
      new SlugKeywordAssessment(config?.slugKeyword),
      new SingleH1Assessment(config?.singleH1),
      new SchemaAssessment(config?.schema),
      new FAQsAssessment(config?.faqs),
      new KeywordFAQsAssessment(config?.keywordFaqs),
      new FAQsStructureDataAssessment(config?.faqsStructuredData),
      new InvalidCharactersInUrl(config?.charactersUrl),
      new RelatedKeywordsDensityAssessment(config?.relatedKeywordsDensity),
      new TextLengthAssessment(config?.textLength),
    ];
  }
}
